import React, { useState } from 'react';
import { Send, Loader2, X, AlertCircle } from 'lucide-react';
import { API_PATH, request } from '../../config/api';
import styles from './TransferEventModal.module.css';

const API_URL = `${API_PATH}/events`;

export default function TransferEventModal({ event, onClose, onToast, onTransferRequestCreated }) {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleTransfer = async (e) => {
        e.preventDefault();
        const trimmed = email.trim().toLowerCase();
        if (!trimmed) return;
        setError('');
        setLoading(true);
        try {
            const res = await request(`${API_URL}/${event.id}/transfer`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ newOwnerEmail: trimmed }),
            });
            const data = await res.json().catch(() => ({}));
            if (res.ok) {
                onTransferRequestCreated?.();
                onToast('Transfer request sent. Event will move when they accept.');
                onClose();
            } else {
                setError(data.error || 'Transfer failed.');
            }
        } catch (err) {
            console.error('Transfer failed', err);
            setError('Transfer failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.transferModal} onClick={e => e.stopPropagation()}>
                <div className={styles.transferHeader}>
                    <h3 className={styles.transferTitle}>Transfer Event</h3>
                    <button className={styles.closeBtn} onClick={onClose} aria-label="Close"><X size={18} /></button>
                </div>
                <p className={styles.transferDesc}>
                    Send a transfer request for <strong>"{event.name}"</strong>. The event will move to their account only after they accept. They must have an approved admin account.
                </p>
                <p className={styles.transferHint}>
                    Sent to wrong email? Cancel the request from the list below or in Transfer History, then send again to the correct email.
                </p>
                {error && (
                    <p className={styles.transferError} role="alert">
                        <AlertCircle size={14} aria-hidden />
                        {error}
                    </p>
                )}
                <form className={styles.transferForm} onSubmit={handleTransfer}>
                    <input
                        type="email"
                        className={styles.transferInput}
                        placeholder="owner@example.com"
                        value={email}
                        onChange={e => { setEmail(e.target.value); setError(''); }}
                        required
                        autoFocus
                        disabled={loading}
                        aria-invalid={!!error}
                    />
                    <div className={styles.transferActions}>
                        <button type="button" className={styles.transferCancel} onClick={onClose}>Cancel</button>
                        <button type="submit" className={styles.transferSubmit} disabled={loading}>
                            {loading ? <Loader2 size={14} className={styles.spin} /> : <Send size={14} />}
                            Transfer
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
